import type { MbcBriefAssetTarget } from "@nlc/shared-types";

import { Upload } from "lucide-react";

import { Button } from "@/components/button";
import { FileUploadTrigger } from "@/components/file-uploader/components/FileUploadTrigger";

import { ASSET_COPY } from "./asset-copy";

export function AssetDropzone({ target }: { target: MbcBriefAssetTarget }) {
  const { dropzoneTitle, examples } = ASSET_COPY[target];

  return (
    <FileUploadTrigger>
      <Button
        className="flex min-h-[216px] w-full cursor-pointer flex-col items-center justify-center rounded-[14px] border-[1.5px] border-dashed border-border-primary bg-bg-primary px-2xl pb-3xl pt-4xl text-center outline-hidden transition-colors hover:border-border-brand-solid focus-visible:ring-2 focus-visible:ring-fg-brand-primary group-data-[drop-target]/panel:border-border-brand-solid"
        variant="unstyled"
      >
        <span className="mb-lg grid size-12 place-items-center rounded-xl border border-border-secondary bg-bg-primary text-text-primary shadow-xs">
          <Upload className="size-5" />
        </span>
        <span
          aria-level={3}
          className="text-md font-semibold text-text-primary"
          role="heading"
        >
          {dropzoneTitle}
        </span>
        <span className="mt-xxs text-sm text-text-quaternary">
          <span className="font-semibold text-text-brand-primary">
            Click to upload
          </span>{" "}
          or drag and drop
        </span>
        <span className="mt-xl flex flex-wrap justify-center gap-md">
          {examples.map(({ icon: Icon, label }) => (
            <span
              className="inline-flex items-center gap-sm rounded-full border border-border-secondary bg-bg-secondary py-xxs pl-md pr-lg text-xs font-medium text-text-secondary"
              key={label}
            >
              <Icon className="size-3.5 text-text-quaternary" />
              {label}
            </span>
          ))}
        </span>
      </Button>
    </FileUploadTrigger>
  );
}
